import React from "react";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import registrarImage from "../assets/img/leadership/Dr. B.P. Bhol.png";

export default function HonorableRegistrar() {
  return (
    <>
      <MetaInfo param="" id="about" />

      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">

        <section className="relative isolate min-h-[60vh] overflow-hidden bg-[#071A2F] text-white">
          <div className="absolute inset-0 -z-30 bg-[#071A2F]" />
          <div className="absolute left-0 top-0 -z-20 h-full w-full bg-[radial-gradient(circle_at_15%_20%,rgba(139,30,63,0.24),transparent_32%),radial-gradient(circle_at_80%_15%,rgba(213,173,87,0.16),transparent_28%)]" />
          <div className="absolute right-0 top-0 -z-10 hidden h-full w-[46%] border-l border-white/10 bg-white/[0.025] lg:block" />
          <div className="absolute right-[7%] top-[18%] -z-10 hidden h-[420px] w-[420px] rounded-full border border-[#D5AD57]/15 xl:block" />
          <div className="absolute right-[11%] top-[23%] -z-10 hidden h-[320px] w-[320px] rounded-full border border-white/10 xl:block" />

          <div className="mx-auto grid min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-end gap-12 pb-0 pt-[70px] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_500px] lg:items-center lg:gap-20 lg:pb-0">
            <div className="max-w-[700px]">
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Hon'ble Registrar
              </div>

              <h1 className="mt-7 max-w-[840px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.2vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                Strengthening the University&apos;s
                <span className="block text-[#D5AD57]">
                  academic administration.
                </span>
              </h1>

              <p className="mt-8 max-w-[640px] text-[17px] leading-8 text-white/65">
                Supporting quality education, effective administration and an environment where students can pursue their academic and professional goals.
              </p>
            </div>

            <div className="relative self-end">
              <div className="absolute -left-8 top-16 hidden h-[72%] w-[1px] bg-[#D5AD57]/60 lg:block" />
              <div className="relative min-h-[560px] overflow-hidden bg-[#EAE5DA] sm:min-h-[640px] lg:min-h-[690px]">
                <img src={registrarImage} alt="Dr. B.P. Bhol" className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/45 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 border-t border-white/15 bg-[#071A2F]/75 px-7 py-6 backdrop-blur-md">
                  <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-white">Dr. B.P. Bhol</p>
                  <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">Hon'ble Registrar</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
          <div className="absolute left-0 top-0 h-full w-px bg-[#071A2F]/[0.04]" />
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[330px_1fr] lg:gap-24">
            <aside className="lg:sticky lg:top-[160px] lg:self-start">
              <div className="border-t border-[#8B1E3F] pt-6">
                <span className="text-xs font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">Hon'ble Registrar</span>
                <h2 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.05] text-[#071A2F]">Dr. B.P. Bhol</h2>
              </div>

              <div className="mt-10 flex items-center gap-4 border-y border-[#071A2F]/10 py-6">
                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[64px] leading-none text-[#D5AD57]">“</span>
                <span className="h-px flex-1 bg-[#071A2F]/10" />
              </div>
            </aside>

            <div className="relative">
              <div className="absolute -left-10 top-0 hidden h-full w-px bg-[#071A2F]/10 lg:block" />
              <div className="space-y-8">
                <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] font-normal leading-[1.35] text-[#071A2F]">On behalf of the Administration, faculty, and staff of ISBM University. I am pleased to extend a warm welcome to all of you.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">Education is a powerful tool that can break down the barriers to development, and higher education equips individuals with the ability to make better choices, gain access to economic stability, and achieve financial security. Our university is dedicated to providing quality education through the use of the latest technology and high academic standards. We have an excellent team of highly qualified, committed, and friendly staff members who are here to support our students and provide them with the best education possible. Our faculty members are also committed to advising and working with students to help them achieve their academic and professional goals. At ISBM University, we are committed to providing our students with improved career opportunities and greater socio-cultural awareness through our comprehensive curricular, co-curricular, and extra-curricular activities.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">Our ultimate aim is to support our students and professionals in achieving success in their personal and professional lives, this results in increased career prospects and earning potential. Further to enhance our student's career we offer internships that provide practical opportunities for skill acquisition and career development.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">The University provides affordable courses so that it will benefit most of the students and professionals across the world. ISBM University also welcomes world reputed universities and academic institutions for academic partnership and educational exchange programmes and recognitions.</p>
                <p className="whitespace-pre-line text-[17px] leading-9 text-[#4F5D70]">I take this opportunity to invite the aspirants to the University for a better learning experience.
                  At ISBM University, we strive to empower our students with the knowledge, skills, and confidence to achieve their full potential and succeed in their personal and professional lives. We hope that your experience at ISBM University will be both rewarding and fulfilling, and that it will leave a lasting impression on your mind.</p>

              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
